import { Center, Spinner } from "@chakra-ui/react";

export default function RouteFallback() {
  return (
    <Center minH="50dvh">
      <Spinner size="lg" />
    </Center>
  );
}
